// close submenu on escape
document.addEventListener("keydown", function (event) {
  if (event.key === "Escape") {
    const submenus = document.querySelectorAll(".header__submenu");
    submenus.forEach((submenu) => {
      submenu.style.display = "none";
    });
  }
});

document.addEventListener("keydown", function (event) {
  if (event.key !== "Escape") {
    const submenus = document.querySelectorAll(".header__submenu");
    submenus.forEach((submenu) => {
      submenu.style.display = "";
    });
  }
});